/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  DeferredCostLineItemExportErrorsSearchResponse,
  DeferredCostLineItemFilterRequest,
  DeferredCostLineItemListSummaryDto,
  DeferredCostLineItemsSearchResponse,
  ReleasePlanCreateRequest,
  ReleasePlanItemDto,
  Update2Payload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DeferredCostLineItemController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags deferred-cost-line-item-controller
   * @name Update2
   * @request PUT:/api/v1/deferred-costs/line-items
   */
  update = (data: Update2Payload, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/deferred-costs/line-items`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updatePath = '/v1/deferred-costs/line-items'
  static updateMethod = 'PUT'
  /**
   * No description
   *
   * @tags deferred-cost-line-item-controller
   * @name GetSummary2
   * @request POST:/api/v1/deferred-costs/line-items/summary
   */
  getSummary = (data: DeferredCostLineItemFilterRequest, params: RequestParams = {}) =>
    this.http.request<DeferredCostLineItemListSummaryDto, any>({
      path: `/v1/deferred-costs/line-items/summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getSummaryPath = '/v1/deferred-costs/line-items/summary'
  static getSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags deferred-cost-line-item-controller
   * @name SelectAllLineItems
   * @request POST:/api/v1/deferred-costs/line-items/select-all
   */
  selectAllLineItems = (data: DeferredCostLineItemFilterRequest, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v1/deferred-costs/line-items/select-all`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static selectAllLineItemsPath = '/v1/deferred-costs/line-items/select-all'
  static selectAllLineItemsMethod = 'POST'
  /**
   * No description
   *
   * @tags deferred-cost-line-item-controller
   * @name SearchLineItems
   * @request POST:/api/v1/deferred-costs/line-items/search
   */
  searchLineItems = (data: DeferredCostLineItemFilterRequest, params: RequestParams = {}) =>
    this.http.request<DeferredCostLineItemsSearchResponse, any>({
      path: `/v1/deferred-costs/line-items/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchLineItemsPath = '/v1/deferred-costs/line-items/search'
  static searchLineItemsMethod = 'POST'
  /**
   * No description
   *
   * @tags deferred-cost-line-item-controller
   * @name PreviewReleasePlan
   * @request POST:/api/v1/deferred-costs/line-items/preview
   */
  previewReleasePlan = (data: ReleasePlanCreateRequest, params: RequestParams = {}) =>
    this.http.request<ReleasePlanItemDto[], any>({
      path: `/v1/deferred-costs/line-items/preview`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static previewReleasePlanPath = '/v1/deferred-costs/line-items/preview'
  static previewReleasePlanMethod = 'POST'
  /**
   * No description
   *
   * @tags deferred-cost-line-item-controller
   * @name DownloadLineItemCsv
   * @request POST:/api/v1/deferred-costs/line-items/csv-configurations/{templateId}/download
   */
  downloadLineItemCsv = (
    templateId: string,
    data: DeferredCostLineItemFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/deferred-costs/line-items/csv-configurations/${templateId}/download`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadLineItemCsvPath =
    '/v1/deferred-costs/line-items/csv-configurations/${templateId}/download'
  static downloadLineItemCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags deferred-cost-line-item-controller
   * @name SearchExportErrors
   * @request GET:/api/v1/deferred-costs/line-items/{lineItemId}/export-errors
   */
  searchExportErrors = (lineItemId: string, params: RequestParams = {}) =>
    this.http.request<DeferredCostLineItemExportErrorsSearchResponse, any>({
      path: `/v1/deferred-costs/line-items/${lineItemId}/export-errors`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static searchExportErrorsPath = '/v1/deferred-costs/line-items/${lineItemId}/export-errors'
  static searchExportErrorsMethod = 'GET'
}
